module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-button-root",
    class: _vm.rootClassName,
    on: {
      "click": _vm.toggle
    }
  }, [_c('div', {
    staticClass: "line line1"
  }), _vm._v(" "), _c('div', {
    staticClass: "line line2"
  }), _vm._v(" "), _c('div', {
    staticClass: "line line3"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fe7cede"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/button/menu-button.vue
// module id = 193
// module chunks = 0